import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() pageNumber!: number;
  @Input() pageSize!: number;
  @Input() itemsCount!: number | any;
  @Input() recordsTotal!: number;
  @Input() totalPages!: number;
  @Output() pageChange = new EventEmitter<number>();
  tempPageNumber: number = 1; // this is just used to temporarily store the current page number before it is updated

  constructor() { 
  }
  
  ngOnInit(): void {
    // Initialize tempPageNumber  with the initial value of pageNumber
    this.tempPageNumber = this.pageNumber;
  }

  goToPage(event: any) {   
    if (parseInt(event.target.value) >= 1 && parseInt(event.target.value) <= this.totalPages) {
      this.pageNumber = parseInt(event.target.value);
      this.tempPageNumber = parseInt(event.target.value);
      this.pageChange.emit(this.pageNumber);
    }
  }

  // nextPage() {
  //   this.pageChange.emit(this.pageNumber + 1);
  // }

  // previousPage() {
  //   this.pageChange.emit(this.pageNumber - 1);
  // }

  // firstPage() {
  //   this.pageChange.emit(1);
  // }

  // lastPage() {
  //   this.pageChange.emit(this.totalPages);
  // }


  nextPage() {
    if (this.pageNumber < this.totalPages) {
      this.pageChange.emit(this.pageNumber + 1);
    }
  }
  
  previousPage() {
    if (this.pageNumber > 1) {
      this.pageChange.emit(this.pageNumber - 1);
    }
  }
  
  firstPage() {
    if (this.pageNumber !== 1) {
      this.pageChange.emit(1);
    }
  }
  
  lastPage() {
    if (this.pageNumber !== this.totalPages) {
      this.pageChange.emit(this.totalPages);
    }
  }
  

}
